
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components';
import QuickChatDetailsPage from './QuickChatDetailsPage';
import { useAuthService } from '../Context/AuthContext';
import QuickChatClosedPage from './QuickChatClosedPage';
import QuickChat from '../Components/QuickChat/QuickChat';
import { useQuickChatService } from '../Context/QuickChatContext';

import { useParams } from 'react-router';
import { useTranslate } from '@tolgee/react';
import { useGenericComponentsStateService } from '../Context/GenericComponentsStateContext';
import { useNotify } from '../Helpers/Notifications';


const QuickChatPage = () => {

  const { setLoading } = useGenericComponentsStateService()
  const { getTranslationsLanguages } = useAuthService();
  const { quickChat, getQuickChat, anonymousUserExist, joinQuickChat, getMessagesQuickChat } = useQuickChatService();
  const [language, setLanguage] = useState(null);
  const [name, setName] = useState("");
  const { hashId } = useParams();
  const { notifySuccess, notifyError, notifyInfo } = useNotify();
  const { t } = useTranslate();
  const handleGetQuickChat = (hashId) => {
    setLoading(true);
    getQuickChat(
      hashId,
      (response) => {
        setLoading(false);
      },
      (error) => {
        if (error.response?.data?.message === "Conversation not open") {
          console.log(error);
          setLoading(false);
          return
        }
        notifyError(t('general.something_wrong'));
        console.log(error);
        setLoading(false);
      }
    )
  }

  const handleJoinQuickChat = (hashId, name, language) => {
    setLoading(true);
    joinQuickChat(
      hashId, name, language,
      (response) => {
        // setLoading(false);
        handleGetQuickChat(hashId);
      },
      (error) => {
        setLoading(false)
        console.log(error);
        notifyError(t('general.something_wrong'));
      }
    )
  }

  const handleContinue = () => {
    handleJoinQuickChat(hashId, name, language,);
  }

  useEffect(() => {
    getTranslationsLanguages(function () { },
      function () { }
    )
  }, [])

  useState(() => {
    handleGetQuickChat(hashId);
  }, [hashId])

  useEffect(() => {
    function blurInputs() {
      const inputs = document.querySelectorAll("input");

      inputs.forEach((input) => {
        input.blur();
      });
    }
    document.addEventListener("touchmove", blurInputs);

  }, [])

  return (
    <Container>
      {quickChat != null &&
        <Content>
          {
            anonymousUserExist ?
              <QuickChat setLoading={setLoading} />
              :
              <QuickChatDetailsPage
                name={name}
                setLanguage={setLanguage}
                setName={setName}
                language={language}
                handleContinue={handleContinue}
                quickChat={quickChat}
              />
          }
        </Content>
      }
      {quickChat === null && <QuickChatClosedPage />}

    </Container>

  )
}

export default QuickChatPage
const Container = styled.div`
      background:${({ theme }) => theme.menu.background};
      display:flex;
      flex-direction:column;
      width:100%;
      max-height:100svh;
      height:100%;
`;
const Content = styled.div`
 display:flex;
      flex-direction:column;
      width:100%;
         height:100%;
`
